import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {StyleClassModule} from 'primeng/styleclass';
import {LayoutService} from '@/layout/service/layout.service';
import {InputText} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {IconField} from 'primeng/iconfield';
import {InputIcon} from 'primeng/inputicon';
import {FormsModule} from '@angular/forms';
import {AppSidebar} from './app.sidebar';
import Keycloak from 'keycloak-js';
import { environment } from '../../../environments/environment';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, FormsModule, AppSidebar, ButtonModule],
    template: `
        <div class="topbar-start">
            <button pButton #menubutton type="button" class="topbar-menubutton p-trigger duration-300" (click)="onMenuButtonClick()">
                <i class="pi pi-bars"></i>
            </button>
            <a [routerLink]="['/']" class="app-logo cursor-pointer">
                <img [src]="logoUrl" width="180px" alt="logo-img"/>
            </a>
        </div>
        <div class="layout-topbar-menu-section">
            <div app-sidebar></div>
        </div>
        <div class="topbar-end">
            <ul class="topbar-menu">
                <li class="topbar-item">
                    <a pStyleClass="@next" enterFromClass="!hidden" enterActiveClass="animate-scalein" leaveToClass="!hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true" class="cursor-pointer">
                        <button pButton type="button" icon="fa-regular fa-user fa-lg" class="flex-shrink-0 !rounded-xl !w-8 !h-8" text="true"></button>
                    </a>
                    <ul [class]="'topbar-menu active-topbar-menu !p-6 w-60 z-50 !hidden'">
                        <li role="menuitem" class="!m-0 !mb-4">
                            <a
                                (click)="onUserProfileClick()"
                                class="cursor-pointer flex items-center hover:text-primary-500 duration-200"
                                pStyleClass="@grandparent"
                                enterFromClass="!hidden"
                                enterActiveClass="animate-scalein"
                                leaveToClass="!hidden"
                                leaveActiveClass="animate-fadeout"
                                [hideOnOutsideClick]="true"
                            >
                                <i class="fa-solid fa-address-card mr-2"></i>
                                <span>Dati utente</span>
                            </a>
                        </li>
                        <li role="menuitem" class="!m-0">
                            <a
                                (click)="onLogoutClick()"
                                class="cursor-pointer flex items-center hover:text-primary-500 duration-200"
                                pStyleClass="@grandparent"
                                enterFromClass="!hidden"
                                enterActiveClass="animate-scalein"
                                leaveToClass="!hidden"
                                leaveActiveClass="animate-fadeout"
                                [hideOnOutsideClick]="true"
                            >
                                <i class="fa-solid fa-right-from-bracket mr-2"></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <!--<li>
                    <button pButton type="button" icon="pi pi-cog" class="flex-shrink-0 !rounded-xl !w-8 !h-8" (click)="onConfigButtonClick()"></button>
                </li>-->
            </ul>
        </div>
    `,
    host: {
        class: 'layout-topbar'
    }
})
export class AppTopbar {
    layoutService = inject(LayoutService);
    keycloak = inject(Keycloak);
    readonly logoUrl = environment.logoUrl;

    el = inject(ElementRef);

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild(AppSidebar) appSidebar!: AppSidebar;


    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onConfigButtonClick() {
        this.layoutService.toggleConfigSidebar();
    }

    onUserProfileClick() {
        // Chiudi il menu
        document.body.click();
        // Implementa la logica per visualizzare i dati utente
        console.log('Visualizza dati utente');
    }

    async onLogoutClick() {
        // Chiudi il menu
        document.body.click();

        try {
            // Effettua il logout con Keycloak
            await this.keycloak.logout({
                redirectUri: environment.afterLoginRedirect
            });
        } catch (error) {
            console.error('Errore durante il logout:', error);
        }
    }

    // Mantieni questo metodo per compatibilit� se necessario
    onTopbarItemClick() {
        document.body.click();
    }
}
